import {
  proxyServer
} from './connection';

export const getLead = leadId => {
  return async () => {
    return await proxyServer.get(`/boots/leads/${leadId}`);
  };
};

export const postLead = formValues => {
  return async () => {
    return await proxyServer.post('/boots/leads/', formValues);
  };
};

export const putLead = (id, formValues) => {
  return async () => {
    return await proxyServer.put('/boots/leads/', Object.assign({}, formValues, {
      id: id
    }));
  };
};

export const getEmail = email => {
  return async () => {
    return await proxyServer.get(`/boots/leads?search=email&email=${email}`);
  };
};

export const getUUID = email => {
  return async () => {
    return await proxyServer.get(`/boots/lead?search=email&email=${email}`);
  };
}

export const patchInitialCheck = leadId => {
  return async () => {
    return await proxyServer.patch('/boots/onfido-initial-check/', { 'id': leadId });
  };
};

export const patchDocumentUpload = (leadId, document, type, side = 'front') => {

  let data = new FormData();
  data.append("id", leadId);
  data.append("document", document);
  data.append("type", type);
  data.append("side", side);

  return async () => {
    return await proxyServer.patch('/boots/onfido-document-check/', data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "*/*",
        "Cache-Control": "no-cache",
        "Postman-Token": "7a2e2be8-b1aa-4f0c-a347-09828a7bfe0c,b2625397-9c9a-4a0c-9af9-d3c12bf5debc",
        "cache-control": "no-cache"
      }
    });
  };
};

export const postPayslipUpload = (document) => {

  let data = new FormData();
  data.append("document", document);

  return async () => {
    return await proxyServer.post('/payslip-upload/', data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "*/*",
        "Cache-Control": "no-cache",
        "Postman-Token": "7a2e2be8-b1aa-4f0c-a347-09828a7bfe0c,b2625397-9c9a-4a0c-9af9-d3c12bf5debc",
        "cache-control": "no-cache"
      }
    });
  };
};
